<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Staff Details</h3>
        <button @click="close" class="close-btn">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>

      <div class="modal-body">
        <div v-if="loading" class="loading-spinner">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>

        <div v-else-if="staffDetails" class="staff-details">
          <div class="detail-item">
            <strong>Name:</strong>
            <span>{{ staffDetails.name || 'N/A' }}</span>
          </div>

          <div class="detail-item">
            <strong>Staff Type:</strong>
            <span>{{ staffDetails.staf_type || 'N/A' }}</span>
          </div>

          <div class="detail-item">
            <strong>Status:</strong>
            <span :class="{
              'status-badge status-active': staffDetails.is_active === '1',
              'status-badge status-inactive': staffDetails.is_active === '0'
            }">
              {{ staffDetails.is_active === '1' ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>

        <div v-else class="error-message">
          <p>No staff details found.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { viewStaffDetailsById } from "@/services/dataService";

export default {
  name: 'ViewDistributorStaff',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    staffId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      staffDetails: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal && this.staffId) {
        this.loadStaffDetails();
      } else {
        this.staffDetails = null;
      }
    },
    staffId() {
      if (this.show && this.staffId) {
        this.loadStaffDetails();
      }
    }
  },
  methods: {
    async loadStaffDetails() {
      if (!this.staffId) return;

      this.loading = true;
      try {
        const token = localStorage.getItem('token_set');
        const response = await viewStaffDetailsById(this.staffId, token);
        this.staffDetails = response.data.data || null;
      } catch (error) {
        console.error("Error fetching staff details:", error);
        this.staffDetails = null;
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background-color: white;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 0 20px;
  border-bottom: 1px solid #e9ecef;
  margin-bottom: 0;
}

.modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #333;
    background-color: #f8f9fa;
    border-radius: 50%;
  }
}

.modal-body {
  padding: 20px;
}

.loading-spinner {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;

  .fa-spinner {
    margin-right: 8px;
  }
}

.staff-details {
  .detail-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #f8f9fa;

    &:last-child {
      border-bottom: none;
    }

    strong {
      color: #495057;
      font-weight: 600;
    }

    span:not(.status-badge) {
      color: #6c757d;
      text-align: right;
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active {
  background-color: #28a745;
  color: #fff;
}

.status-inactive {
  background-color: #dc3545;
  color: #fff;
}

.error-message {
  text-align: center;
  padding: 40px 20px;
  color: #dc3545;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;

  &.btn-secondary {
    background-color: #6c757d;
    color: white;

    &:hover {
      background-color: #5a6268;
    }
  }
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-header {
    padding: 15px 15px 0 15px;
  }

  .modal-body {
    padding: 15px;
  }

  .modal-footer {
    padding: 15px;
  }

  .detail-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    span:not(.status-badge) {
      text-align: left;
    }
  }
}
</style>